import React, {useEffect, useState} from "react";
import {Outlet} from "react-router-dom";
import "./style.scss"


const MainLayout = () => {

    const [scrollTop, setScrollTop] = useState(0);
    const [reachedEnd, setReachedEnd] = useState(false);

    const [currentSection, setCurrentSection] = useState("");

    const scrollUp = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    };

    // const scrollToSecondSlide = () => {
    //     window.scrollTo({top: window.innerHeight - 79, left: 0, behavior: 'smooth'});
    // };

    const scrollToDiv = (id: string) => {
        document.getElementById(id)?.scrollIntoView({behavior: 'smooth'})
    }


    useEffect(() => {
        function onScroll() {
            let currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
            setScrollTop(currentPosition <= 0 ? 0 : currentPosition);

            let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
            const bottom = scrollHeight - clientHeight <= currentPosition + 50;
            setReachedEnd(bottom);
        }

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollTop]);

    useEffect(() => {
        const animations = document.querySelectorAll('.collider')

        const observer =
            new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('--intersected');

                            if(entry.target.id == "page-header" || entry.target.id == "section-1" || entry.target.id == "section-2" || entry.target.id == "section-3") {
                                setCurrentSection("about");
                            }
                            else if (entry.target.id == "services") {
                                setCurrentSection("services");
                            }
                            else if (entry.target.id == "feedback") {
                                setCurrentSection("feedback");
                            }
                        }
                    })
                },
                {
                    threshold: 0.20
                }
            );

        for (let i = 0; i < animations.length; i++) {
            const elements = animations[i];

            observer.observe(elements);
        }
    }, []);


    return (
        <>
            <div className="page-container">

                <header id="page-header" className="page-header collider">
                    <div className="page-header-bar">
                        <div className={"page-header-bar-container" + (scrollTop > 0 ? " --fixed" : "")}>
                            <div className="page-header-bar-container-content">

                                <a className="logo" href="#">
                                    <svg viewBox="0 0 395.52 247.2" width="100" height="50">
                                        <g transform="matrix(1,0,0,1,75.54432000000001,51.38851045735477)">
                                            <svg viewBox="0 0 244.43135999999996 144.42297908529045"
                                                 height="144.42297908529045" width="244.43135999999996">
                                                <g>
                                                    <svg viewBox="0 0 244.43135999999996 144.42297908529045"
                                                         height="144.42297908529045" width="244.43135999999996">
                                                        <g>
                                                            <svg viewBox="0 0 244.43136 144.42297908529048"
                                                                 height="144.42297908529045"
                                                                 width="244.43135999999996">
                                                                <g>
                                                                    <svg viewBox="0 0 244.43136 144.42297908529048"
                                                                         height="144.42297908529048"
                                                                         width="244.43136">
                                                                        <g id="textblocktransform">
                                                                            <svg
                                                                                viewBox="0 0 244.43136 144.42297908529048"
                                                                                height="144.42297908529048"
                                                                                width="244.43136" id="textblock">
                                                                                <g>
                                                                                    <svg
                                                                                        viewBox="0 0 244.43136 144.42297908529048"
                                                                                        height="144.42297908529048"
                                                                                        width="244.43136">
                                                                                        <g transform="matrix(1,0,0,1,0,0)">
                                                                                            <svg width="244.43136"
                                                                                                 viewBox="3.25 -35.0099983215332 59.25 35.0099983215332"
                                                                                                 height="144.42297908529048"
                                                                                                 data-palette-color="#2a2c35">
                                                                                                <path
                                                                                                    d="M10.25-7.01L10.25 0 3.25 0 3.25-35.01 10.25-35.01 10.25-17.5 23.29-35.01 31.25-35.01 20.19-20.24 31.25 0 23.29 0 15.6-14.16 10.25-7.01ZM48.51-28L41.5-28 41.5-13.99 48.51-13.99Q49.95-13.99 51.22-14.54 52.49-15.09 53.44-16.04 54.39-16.99 54.94-18.27 55.49-19.56 55.49-21L55.49-21Q55.49-22.44 54.94-23.72 54.39-25 53.44-25.95 52.49-26.9 51.22-27.45 49.95-28 48.51-28L48.51-28ZM41.5-7.01L41.5 0 34.49 0 34.49-35.01 48.51-35.01Q50.44-35.01 52.22-34.51 54-34.01 55.55-33.09 57.1-32.18 58.38-30.9 59.67-29.61 60.58-28.05 61.5-26.49 62-24.71 62.5-22.92 62.5-21L62.5-21Q62.5-18.12 61.4-15.56 60.3-13.01 58.4-11.11 56.49-9.2 53.94-8.11 51.39-7.01 48.51-7.01L48.51-7.01 41.5-7.01Z"
                                                                                                    opacity="1"
                                                                                                    transform="matrix(1,0,0,1,0,0)"
                                                                                                    fill="#2a2c35"
                                                                                                    className="wordmark-text-0"
                                                                                                    data-fill-palette-color="primary"
                                                                                                    id="text-0"></path>
                                                                                            </svg>
                                                                                        </g>
                                                                                    </svg>
                                                                                </g>
                                                                            </svg>
                                                                        </g>
                                                                    </svg>
                                                                </g>
                                                            </svg>
                                                        </g>
                                                    </svg>
                                                </g>
                                            </svg>
                                        </g>
                                        <path
                                            d="M254.03 45.389L254.03 1.893 10.616 1.893 10.616 245.307 254.03 245.307 254.03 201.811 241.006 201.811 241.006 232.283 23.64 232.283 23.64 14.917 241.006 14.917 241.006 45.389Z"
                                            fill="#2a2c35" stroke="transparent"
                                            data-fill-palette-color="tertiary"></path>
                                    </svg>
                                </a>

                                <ul className="page-header-nav">
                                    <li>
                                        <a className={(currentSection == "about" ? "--active" : "")}
                                           onClick={() => scrollToDiv("section-1")}
                                        >
                                            О нас
                                        </a>
                                    </li>
                                    <li>
                                        <a className={(currentSection == "services" ? "--active" : "")}
                                           onClick={() => scrollToDiv("services")}
                                        >
                                            Услуги
                                        </a>
                                    </li>
                                    <li>
                                        <a className={(currentSection == "feedback" ? "--active" : "")}
                                           onClick={() => scrollToDiv("feedback")}
                                        >
                                            Обратная связь
                                        </a>
                                    </li>
                                </ul>

                                <ul className="options">

                                </ul>

                            </div>
                        </div>
                    </div>

                    <div className="page-header-hero">

                        <div
                            className="page-header-hero-wrapper"
                            style={{opacity: (1 - scrollTop / window.innerHeight * 2)}}>
                            <div className="page-header-hero-content">
                                <h1 className="page-header-hero-title fade-in-from-bottom section-text-animated">
                                    <span>Корпоративные решения</span></h1>
                                <div
                                    className="page-header-hero-description fade-in-from-bottom section-text-animated">для
                                    вашего бизнеса
                                </div>
                                <a className="page-header-hero-button fade-in-from-bottom section-text-animated"
                                   onClick={() => scrollToDiv("feedback")}>
                                    <span>Связаться с нами</span>
                                </a>
                            </div>
                        </div>

                        <div className="page-header-hero-background-container">
                            <div className="page-header-hero-background"
                                 style={{
                                     transform: ("translate(0px, " + scrollTop / 3 + "px)")
                                 }}>
                            </div>
                        </div>

                        <button
                            className="page-header-goto-section-button"
                            onClick={()=>scrollToDiv("section-1")}
                        >
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#000000"
                                width="30px"
                                height="30px"
                                viewBox="0 0 32 32">
                                <path
                                    d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z"
                                    fill="#000000"
                                />
                            </svg>
                        </button>

                    </div>

                </header>

                <div className="main-content">
                    <Outlet/>
                </div>

                <footer className="page-footer">

                    <div className="page-footer-container">

                        <div className="page-footer-content">
                            <div className="footer-logo">
                                <svg viewBox="0 0 395.52 247.2" width="100" height="50">
                                    <g transform="matrix(1,0,0,1,75.54432000000001,51.38851045735477)">
                                        <svg viewBox="0 0 244.43135999999996 144.42297908529045"
                                             height="144.42297908529045" width="244.43135999999996">
                                            <g>
                                                <svg viewBox="0 0 244.43135999999996 144.42297908529045"
                                                     height="144.42297908529045" width="244.43135999999996">
                                                    <g>
                                                        <svg viewBox="0 0 244.43136 144.42297908529048"
                                                             height="144.42297908529045"
                                                             width="244.43135999999996">
                                                            <g>
                                                                <svg
                                                                    viewBox="0 0 244.43136 144.42297908529048"
                                                                    height="144.42297908529048"
                                                                    width="244.43136">
                                                                    <g id="textblocktransform">
                                                                        <svg
                                                                            viewBox="0 0 244.43136 144.42297908529048"
                                                                            height="144.42297908529048"
                                                                            width="244.43136"
                                                                            id="textblock">
                                                                            <g>
                                                                                <svg
                                                                                    viewBox="0 0 244.43136 144.42297908529048"
                                                                                    height="144.42297908529048"
                                                                                    width="244.43136">
                                                                                    <g transform="matrix(1,0,0,1,0,0)">
                                                                                        <svg
                                                                                            width="244.43136"
                                                                                            viewBox="3.25 -35.0099983215332 59.25 35.0099983215332"
                                                                                            height="144.42297908529048"
                                                                                            data-palette-color="#2a2c35">
                                                                                            <path
                                                                                                d="M10.25-7.01L10.25 0 3.25 0 3.25-35.01 10.25-35.01 10.25-17.5 23.29-35.01 31.25-35.01 20.19-20.24 31.25 0 23.29 0 15.6-14.16 10.25-7.01ZM48.51-28L41.5-28 41.5-13.99 48.51-13.99Q49.95-13.99 51.22-14.54 52.49-15.09 53.44-16.04 54.39-16.99 54.94-18.27 55.49-19.56 55.49-21L55.49-21Q55.49-22.44 54.94-23.72 54.39-25 53.44-25.95 52.49-26.9 51.22-27.45 49.95-28 48.51-28L48.51-28ZM41.5-7.01L41.5 0 34.49 0 34.49-35.01 48.51-35.01Q50.44-35.01 52.22-34.51 54-34.01 55.55-33.09 57.1-32.18 58.38-30.9 59.67-29.61 60.58-28.05 61.5-26.49 62-24.71 62.5-22.92 62.5-21L62.5-21Q62.5-18.12 61.4-15.56 60.3-13.01 58.4-11.11 56.49-9.2 53.94-8.11 51.39-7.01 48.51-7.01L48.51-7.01 41.5-7.01Z"
                                                                                                opacity="1"
                                                                                                transform="matrix(1,0,0,1,0,0)"
                                                                                                fill="#616161"
                                                                                                className="wordmark-text-0"
                                                                                                data-fill-palette-color="primary"
                                                                                                id="text-0"></path>
                                                                                        </svg>
                                                                                    </g>
                                                                                </svg>
                                                                            </g>
                                                                        </svg>
                                                                    </g>
                                                                </svg>
                                                            </g>
                                                        </svg>
                                                    </g>
                                                </svg>
                                            </g>
                                        </svg>
                                    </g>
                                    <path
                                        d="M254.03 45.389L254.03 1.893 10.616 1.893 10.616 245.307 254.03 245.307 254.03 201.811 241.006 201.811 241.006 232.283 23.64 232.283 23.64 14.917 241.006 14.917 241.006 45.389Z"
                                        fill="#616161" stroke="transparent"
                                        data-fill-palette-color="tertiary"></path>
                                </svg>
                            </div>
                            <div className="footer-block">
                                <div className="footer-block-title">Контакты</div>
                                <div className="footer-block-text">
                                    Общество с ограниченной ответственностью «Корпоративные решения»
                                    <br/>
                                    ИНН/КПП: 3900019592/390001001
                                    <br/>
                                    ОГРН: 1233900014413
                                    <br/>
                                    ОКВЭД: 62.01
                                    <br/>
                                    Офис: 236001, Калининградская область, г. Калининград, ул. Генерала Челнокова, д. 18Б, помещ. IX
                                    <br/>
                                    Телефон: +7-4012-560-800
                                    <br/>
                                    E-mail: info@turne-trans.ru
                                </div>
                            </div>
                            {/*<div className="footer-block">*/}
                            {/*    <div className="footer-block-title">Офис</div>*/}
                            {/*    <div className="footer-block-text">*/}
                            {/*        236001, Калининградская область<br/>г. Калининград, <br/>ул. Генерала Челнокова, д. 18Б, <br/>помещ.*/}
                            {/*        IX*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*<div className="footer-block">*/}
                            {/*    <div className="footer-block-title">О нас</div>*/}
                            {/*    <div className="footer-block-text">*/}
                            {/*        Мы предоставляем широкий спектр услуг,<br/>*/}
                            {/*        гарантируя качество своих работ.*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>

                    </div>
                </footer>

                <div className="page-sub-footer">
                    <div className="page-sub-footer-container">
                        {new Date().getFullYear()}
                    </div>
                </div>


                <button
                    className="goto-top-button"
                    style={{
                        transform: (reachedEnd ? "translate3d(0, 0, 0)" : "translate3d(0, 150%, 0)")
                    }}
                    onClick={scrollUp}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30px"
                        height="30px"
                        viewBox="0 0 24 24"
                        fill="none">
                        <path
                            d="M20 16L12 8L4 16"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"/>
                    </svg>
                </button>

            </div>
        </>
    );
};

export default MainLayout;
